import React from 'react';

import Icon from '../../components/Icon';

const FooterEasterEgg = () => (
  <div id="footer-easter-egg">
    <div>
      <Icon name="asterisk" className="text-color-white" />
    </div>
  </div>
);

export default FooterEasterEgg;



// WEBPACK FOOTER //
// ./src/modules/FooterEasterEgg/index.js